import store from '@/store';
import { srCreateRepository } from '@/forms/api/repository-factory';
import callApi from '@/lib/helpers/call-api';

const getPayload = () => {
  const { appId, cifnumber } = store.state;
  return {
    "cif-id": cifnumber,
    "app-id": appId,
    "incident_type": "Service Request",
    "problem_code": "ONBOARD-DIGITAL",
    "channel": "DIGITAL",
    "problem_summary": "ONBOARD",
    "cust_notif": "SMS",
    "incident_status": "Reported",
    "customer_remarks": "",
    "time_out": 1
  };
};

export default {
  async srCreate(currentStep, callbacks) {
    const { form } = currentStep;
    let response = false;
    response = await callApi({
      callbacks,
      form,
      formElement: currentStep,
      apiCall: srCreateRepository.srCreate,
      payload: getPayload(),
    });
  }
};
